// extracted by mini-css-extract-plugin
export var calendarView = "_mf-0";